import {
  LOGIN_REQUEST,
  SIGNUP_REQUEST,
  RESET_PASSWORD_REQUEST,
  LOGOUT_REQUEST,
  VALIDATE_TOKEN_REQUEST,
  VALIDATE_TOKEN_COMPLETE,
  SESSION_TIMEOUT,
  DISMISS_SESSION_TIMEOUT,
  SET_INITIAL_PROPS,
  UPDATE_PASSWORD_REQUEST,
  RESET_SUBMIT_SUCCEEDED,
} from './actionTypes';

export const validateToken = { type: VALIDATE_TOKEN_REQUEST };
export const validateTokenComplete = { type: VALIDATE_TOKEN_COMPLETE };

export const login = (params) => ({ type: LOGIN_REQUEST, params });

export const signUpRequest = (params) => ({ type: SIGNUP_REQUEST, params });

export const resetSubmitSucceeded = { type: RESET_SUBMIT_SUCCEEDED };

export const logout = { type: LOGOUT_REQUEST };

export const sessionTimeout = { type: SESSION_TIMEOUT };
export const dismissSessionTimeout = { type: DISMISS_SESSION_TIMEOUT };

export const resetPassword = (password) => ({
  type: RESET_PASSWORD_REQUEST,
  params: {
    password,
    passwordConfirmation: password,
  },
});

export const updatePassword = (params) => ({
  type: UPDATE_PASSWORD_REQUEST,
  params,
});

export const setInitialProps = (props) => ({ type: SET_INITIAL_PROPS, props });
